<div class="d-flex flex-column" style="min-height: 83.5vh;">
  <ats-navbar></ats-navbar>
  <ats-toasts></ats-toasts>
  <div class='container'>
    <ats-alert [alert]="(alert$ | async)" (closeAlert)="closeAlert()"></ats-alert>
    <router-outlet></router-outlet>
  </div>
  <ats-spinner></ats-spinner>
  <ats-footer class="mt-auto"></ats-footer>
</div>
